@if (isDisplayingMaintenanceBanner) {
  <div
    class="top-notification-banner maintenance-banner"
    role="banner"
    [innerHTML]="maintenanceMessageHtml"
  ></div>
}

@if (
  !isDisplayingMaintenanceBanner &&
  displayLoginNotificationBanner &&
  currentUrl === '/login'
  ) {
  <div
    class="top-notification-banner login-banner"
    role="banner"
    [innerHTML]="notificationMessageHtml"
  ></div>
}

<header class="headerv2">
  <h1 class="sr-only">Best Egg</h1>
  <app-be-logo-v2 [isLink]="true"></app-be-logo-v2>
  @if (currentUrl === undefined || !currentUrl.includes('refer-a-friend')) {
    <button
      (click)="onClickFeedback()"
      class="feedback-buttonv2 be-body-text--sm"
      >
      Share your feedback
    </button>
  }
</header>
